(function() {
  var crwnInventory = null;
  function loadInventory() {
    if (crwnInventory !== null) return crwnInventory;
    var el = document.querySelector('[data-variant-inventory]');
    if (!el) { crwnInventory = {}; return crwnInventory; }
    try { crwnInventory = JSON.parse(el.textContent); }
    catch(e) { crwnInventory = {}; }
    return crwnInventory;
  }
  function getStockInfo(sizeValue) {
    var variantScript = document.querySelector('variant-selects script[type="application/json"]');
    if (!variantScript) return { note: '', soldOut: false };
    var variants;
    try { variants = JSON.parse(variantScript.textContent); } catch(e) { return { note: '', soldOut: false }; }
    var selectedColor = null;
    var colorInput = document.querySelector('input[type="radio"][name="Color"]:checked');
    if (colorInput) selectedColor = colorInput.value;
    var match = null;
    variants.forEach(function(v) {
      if (v.option2 === sizeValue && (selectedColor === null || v.option1 === selectedColor)) {
        match = v;
      }
    });
    if (!match) return { note: '', soldOut: false };
    if (match.available === false) return { note: '', soldOut: true };
    var inv = loadInventory()[match.id];
    if (inv === null || inv === undefined || inv >= 20 || inv <= 0) return { note: '', soldOut: false };
    return { note: inv < 10 ? ('Only ' + inv + ' left') : 'Low in stock', soldOut: false };
  }

  function refreshStockNotes() {
    document.querySelectorAll('.product-form__input--dropdown').forEach(function(dd) {
      var sel = dd.querySelector('select.select__select');
      if (!sel || !sel.name || sel.name.toLowerCase().indexOf('size') === -1) return;
      dd.querySelectorAll('.custom-dropdown-item').forEach(function(item) {
        var old = item.querySelector('.crwn-stock-note');
        if (old) old.remove();
        var info = getStockInfo(item.dataset.value);
        if (info.soldOut) {
          item.classList.add('disabled');
          var s = document.createElement('span');
          s.className = 'crwn-stock-note crwn-sold-out';
          s.textContent = 'Sold out';
          item.appendChild(s);
        } else if (info.note) {
          var n = document.createElement('span');
          n.className = 'crwn-stock-note';
          n.textContent = info.note;
          item.appendChild(n);
        }
      });
    });
  }

  function initCustomDropdowns() {
    var dropdowns = document.querySelectorAll('.product-form__input--dropdown');
    dropdowns.forEach(function(dropdown) {
      if (dropdown.dataset.customInit) return;
      dropdown.dataset.customInit = 'true';

      var select = dropdown.querySelector('select.select__select');
      if (!select) return;

      var isSizeDropdown = select.name && select.name.toLowerCase().indexOf('size') !== -1;
      var userHasSelectedSize = false;

      var menu = document.createElement('div');
      menu.className = 'custom-dropdown-menu';
      menu.setAttribute('role', 'listbox');
      menu.style.display = 'none';

      Array.from(select.options).forEach(function(opt, idx) {
        var item = document.createElement('div');
        item.className = 'custom-dropdown-item';
        item.setAttribute('role', 'option');
        item.dataset.value = opt.value;
        // Strip "- Unavailable" suffix from Shopify variant text, keep just the size
        var cleanText = opt.textContent.trim().replace(/\s*-\s*Unavailable\s*$/i, '').replace(/\s*-\s*Sold out\s*$/i, '');
        item.textContent = cleanText;
        if (opt.disabled) item.classList.add('disabled');
        if (opt.selected) item.classList.add('selected');
        if (isSizeDropdown) {
          var info = getStockInfo(opt.value);
          if (info.soldOut) {
            item.classList.add('disabled');
            var soldSpan = document.createElement('span');
            soldSpan.className = 'crwn-stock-note crwn-sold-out';
            soldSpan.textContent = 'Sold out';
            item.appendChild(soldSpan);
          } else if (!opt.disabled && info.note) {
            var noteSpan = document.createElement('span');
            noteSpan.className = 'crwn-stock-note';
            noteSpan.textContent = info.note;
            item.appendChild(noteSpan);
          }
        }
        item.addEventListener('click', function(e) {
          if (item.classList.contains('disabled')) return;
          select.value = opt.value;
          if (isSizeDropdown) {
            userHasSelectedSize = true;
            dropdown.dataset.sizeSelected = 'true';
          }
          select.dispatchEvent(new Event('change', { bubbles: true }));
          dropdown.querySelectorAll('.custom-dropdown-item').forEach(function(i) {
            i.classList.remove('selected');
          });
          item.classList.add('selected');
          updateDisplayedValue();
          closeMenu();
        });
        menu.appendChild(item);
      });

      var display = document.createElement('div');
      display.className = 'custom-dropdown-display';
      function updateDisplayedValue() {
        var sel = select.options[select.selectedIndex];
        var hasValidSelection = sel && sel.value && !sel.disabled;
        if (isSizeDropdown && !userHasSelectedSize) {
          display.textContent = 'Select size';
          display.classList.remove('has-value');
          return;
        }
        if (hasValidSelection) {
          display.textContent = sel.textContent.trim();
          display.classList.add('has-value');
        } else {
          display.textContent = 'Select size';
          display.classList.remove('has-value');
        }
      }
      updateDisplayedValue();

      var selectWrapper = dropdown.querySelector('.select');
      if (selectWrapper) {
        selectWrapper.style.position = 'relative';
        selectWrapper.appendChild(display);
        selectWrapper.appendChild(menu);
      }

      select.style.position = 'absolute';
      select.style.opacity = '0';
      select.style.pointerEvents = 'none';
      select.style.width = '0';
      select.style.height = '0';

      function openMenu() {
        menu.style.display = 'block';
        dropdown.classList.add('open');
      }
      function closeMenu() {
        menu.style.display = 'none';
        dropdown.classList.remove('open');
      }

      dropdown.addEventListener('click', function(e) {
        if (menu.contains(e.target)) return;
        if (menu.style.display === 'none') {
          openMenu();
        } else {
          closeMenu();
        }
      });

      document.addEventListener('click', function(e) {
        if (!dropdown.contains(e.target)) closeMenu();
      });

      select.addEventListener('change', function() {
        dropdown.querySelectorAll('.custom-dropdown-item').forEach(function(i) {
          i.classList.toggle('selected', i.dataset.value === select.value);
        });
        updateDisplayedValue();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomDropdowns);
  } else {
    initCustomDropdowns();
  }

  document.addEventListener('change', function(e) {
    if (e.target.matches('input[type="radio"]')) {
      // Color changed — reset size selection state so user must re-pick
      document.querySelectorAll('.product-form__input--dropdown').forEach(function(dd) {
        var sel = dd.querySelector('select.select__select');
        if (sel && sel.name && sel.name.toLowerCase().indexOf('size') !== -1) {
          dd.dataset.sizeSelected = 'false';
          var display = dd.querySelector('.custom-dropdown-display');
          if (display) {
            display.textContent = 'Select size';
            display.classList.remove('has-value');
          }
        }
      });

      // Wait for Shopify to update, then sync availability from variant JSON
      setTimeout(function() {
        // Get currently selected color
        var selectedColor = null;
        document.querySelectorAll('input[type="radio"][name="Color"]:checked').forEach(function(input) {
          selectedColor = input.value;
        });
        if (!selectedColor) return;

        // Get variant data from the script tag inside variant-selects
        var variantScript = document.querySelector('variant-selects script[type="application/json"]');
        if (!variantScript) return;
        var variants;
        try {
          variants = JSON.parse(variantScript.textContent);
        } catch(e) { return; }

        // Build map of size → available for current color
        var sizeAvailability = {};
        variants.forEach(function(v) {
          if (v.option1 === selectedColor) {
            sizeAvailability[v.option2] = v.available;
          }
        });

        // Sync each dropdown item with availability
        document.querySelectorAll('.product-form__input--dropdown').forEach(function(dd) {
          var sel = dd.querySelector('select.select__select');
          if (!sel || !sel.name || sel.name.toLowerCase().indexOf('size') === -1) return;
          var menu = dd.querySelector('.custom-dropdown-menu');
          if (!menu) return;
          var items = menu.querySelectorAll('.custom-dropdown-item');
          items.forEach(function(item) {
            var sizeValue = item.dataset.value;
            if (sizeAvailability[sizeValue] === false) {
              item.classList.add('disabled');
            } else {
              item.classList.remove('disabled');
            }
          });
        });
        refreshStockNotes();
      }, 400);

      setTimeout(function() {
        initCustomDropdowns();
        forceCTAEnabled();
        attachSizeGate();
      }, 100);
      setTimeout(function() {
        forceCTAEnabled();
        attachSizeGate();
      }, 600);
      setTimeout(function() {
        forceCTAEnabled();
        attachSizeGate();
      }, 1500);
    }
  });

  // Periodic safety check — every 2 seconds, ensure button stays enabled
  setInterval(function() {
    document.querySelectorAll('.product-form__buttons button[type="submit"], button[name="add"]').forEach(function(btn) {
      if (btn.disabled || (btn.textContent.trim().toLowerCase().indexOf('select a size') !== -1)) {
        forceCTAEnabled();
        attachSizeGate();
      }
    });
  }, 2000);

  function forceCTAEnabled() {
    document.querySelectorAll('.product-form__buttons button[type="submit"], button[name="add"]').forEach(function(btn) {
      btn.removeAttribute('disabled');
      btn.dataset.sizePending = 'false';
      var spans = btn.querySelectorAll('span');
      spans.forEach(function(s) {
        if (s.children.length === 0 && s.textContent.trim().length > 0) {
          s.textContent = 'Add to cart';
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forceCTAEnabled);
  } else {
    forceCTAEnabled();
  }
  setTimeout(forceCTAEnabled, 500);
  setTimeout(forceCTAEnabled, 1500);

  function attachSizeGate() {
    document.querySelectorAll('.product-form__buttons button[type="submit"], button[name="add"]').forEach(function(btn) {
      if (btn.dataset.sizeGateAttached === 'true') return;
      btn.dataset.sizeGateAttached = 'true';

      btn.addEventListener('click', function(e) {
        var sizeDropdown = null;
        document.querySelectorAll('.product-form__input--dropdown').forEach(function(dd) {
          var sel = dd.querySelector('select.select__select');
          if (sel && sel.name && sel.name.toLowerCase().indexOf('size') !== -1) {
            sizeDropdown = dd;
          }
        });

        if (!sizeDropdown) return;
        if (sizeDropdown.dataset.sizeSelected === 'true') return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        var menu = sizeDropdown.querySelector('.custom-dropdown-menu');
        if (menu) {
          menu.style.display = 'block';
          sizeDropdown.classList.add('open');
        }
        sizeDropdown.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, true);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachSizeGate);
  } else {
    attachSizeGate();
  }
  setTimeout(attachSizeGate, 500);
  setTimeout(attachSizeGate, 1500);
})();